import {type Range, searchInBlobContent, searchInBlobIncrementally, textMatchable} from '@github-ui/code-nav'

export interface FindInFileRequest {
  query: string
  lines: string[]
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  currentCodeReferences: any
}

export interface FindInFileResponse {
  ranges: Range[]
  query: string
}

export function findInFileWorkerJob({data}: {data: FindInFileRequest}): FindInFileResponse {
  const {query, lines, currentCodeReferences} = data
  let output: Range[] = []

  // incremental search
  if (currentCodeReferences) {
    output = searchInBlobIncrementally(currentCodeReferences, lines, textMatchable(query))
  } else {
    output = searchInBlobContent(lines, textMatchable(query))
  }

  return {ranges: output, query}
}
